import {UISidebarController} from '../../../ui_html/sidebar/UISidebarController'

export class UIDChampionship26SceneController {
    private readonly sidebarController: UISidebarController
    private readonly championship26SceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.championship26SceneContainerDiv = document.getElementById('scene_discord_championship26_container') as HTMLDivElement
    }

    hide() {
        this.championship26SceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.championship26SceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}

